import setSiteMeta from '../base-saving-actions/set-site-meta';

const createPages = (pages) =>
  pages.map(({ html, htmlCheckpoint, ...page }) => setSiteMeta(['pages', page.id], page));

export default createPages;
